"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bwaRedirectInfoWidget = bwaRedirectInfoWidget;
var _utils = require("../../../utils/utils");
var _constants = require("../../../constants/constants");
function bwaRedirectInfoWidget(id, cssClass) {
  return (0, _utils.generateIframe)(id, cssClass, _constants.WIDGET_ENDPOINTS.REDIRECT_INFO);
}
//# sourceMappingURL=bwa-redirect-info.js.map
